/**
  *
  *  ***** DO NOT USE ****
  *  Use sw-input-autocomplete instead.
  *
  * Usage:
  *
  *   data-sw-tags-input
  *   - defaults to "product-tags" also supports "basic"
  *
  * Optional:
  *   data-sw-max-length
  *   - max length of tag
  *
  *   data-sw-autocomplete
  *   - JSON array of autocomplete values
  *
  *   data-sw-on-change-event-name
  *   - string of event name to call on change, sends array of tags as payload
  *
  */

var $   = require('js/sw-jquery/sw-jquery');
var _   = require('underscore');
var sw  = require('js/lib/sw');

var TAGS_INPUT_TYPE_PRODUCT = 'product-tags';
var TAGS_INPUT_TYPE_BASIC = 'basic';

/**
 * @param event
 * @param ui
 */
function doSuggestedPopularityUpdate(event, ui) {
  var suggestedPopularityTagsField = $('input[data-sw-suggested-popularity-tags]');
  var suggestedPopularityTagsObject = suggestedPopularityTagsField.val();
  if(typeof(suggestedPopularityTagsObject) === "string" && suggestedPopularityTagsObject.length === 0) {
    suggestedPopularityTagsObject = {};
  } else {
    suggestedPopularityTagsObject = window.JSON.parse(suggestedPopularityTagsObject);
  }
  suggestedPopularityTagsObject[ui.item.value] = ui.item.tag_popularity_id;
  suggestedPopularityTagsField.val(window.JSON.stringify(suggestedPopularityTagsObject));

}

module.exports = function ($fragment)
{

        $fragment.swFindWithSelf('[data-sw-tags-input]').each(function () {
            var $el = $(this);
            var placeholder = $el.attr('placeholder');
            var tagParams = $el.swDataParams('swTags');
            var inputType = tagParams.swTagsInput || TAGS_INPUT_TYPE_PRODUCT;
            var maxLength = tagParams.swTagsMaxLength;
            var autoCompleteValues = tagParams.swTagsInputAutoComplete || [];
            var onChangeEventName = tagParams.swTagsOnChangeEventName;


            require(['../vendor/jquery.ui.autocomplete'],function () {
                var tagEditorOptions = {
                    maxLength: maxLength,
                    placeholder: placeholder,
                    animateDelete: 0,
                    autocomplete: {
                        source: function (request, response) {
                            $.ajax({
                                url: "/product/tag/typeahead",
                                data: {
                                    inputChars: request.term,
                                    categoryId: $("#category-selector-1").val() | 0
                                },
                                dataType:'json',
                                success: function (data) {
                                    response(data);
                                }
                            });
                        },
                        minLength:2,
                        focus: function (event,ui){
                            $(this).val(ui.item.value);
                            $(this).attr("sw-tag-popularity-id",ui.item.tag_popularity_id);
                        },
                        select: doSuggestedPopularityUpdate
                    },
                    position: { collision: 'none' },
                    forceLowercase: false,
                    sortable: false,
                    beforeTagSave: function (field, editor, tags, tag, val) {
                        //hack to get activity tracking working with clicks
                        var pop_id=editor.find("li").last().find('.active-tag input').attr('sw-tag-popularity-id');
                        doSuggestedPopularityUpdate(null, {item:{tag_popularity_id:pop_id,value:val}});

                    },
                    onChange: function(field, editor, tags) {
                      if (onChangeEventName) {
                        sw.trigger(onChangeEventName, tags);
                      }
                    }
                };

                // If type 'basic'
                if(inputType === TAGS_INPUT_TYPE_BASIC) {
                  tagEditorOptions.beforeTagSave = function() {};
                  tagEditorOptions.autocomplete = {
                    delay: 0,
                    minLength: 0,
                    source: function (request, response) {
                      var values = $el.val();
                      var unused = _.difference(_.map(autoCompleteValues, function(val) {
                        return val + '';
                      }), values.split(','));
                      response(unused);
                    },
                    focus: function (event,ui){
                      $(this).val(ui.item.value);
                    }
                  };
                }

                $el.tagEditor(tagEditorOptions);
            });
        });
};
